const ACTIVE_GROUP_KEYS = {
  id: "active_group_id",
  name: "active_group_name",
  role: "active_group_role",
  capabilities: "active_group_capabilities",
};

export function setActiveGroup(group) {
  if (!group?.id) {
    throw new Error("A valid group is required.");
  }

  localStorage.setItem(
    ACTIVE_GROUP_KEYS.id,
    String(group.id)
  );

  localStorage.setItem(
    ACTIVE_GROUP_KEYS.name,
    group.name || ""
  );

  localStorage.setItem(
    ACTIVE_GROUP_KEYS.role,
    group.role || "member"
  );

  localStorage.setItem(
    ACTIVE_GROUP_KEYS.capabilities,
    JSON.stringify(group.capabilities || {})
  );
}

export function clearActiveGroup() {
  Object.values(ACTIVE_GROUP_KEYS).forEach((key) => {
    localStorage.removeItem(key);
  });
}

export function getActiveGroupId() {
  const value = localStorage.getItem(
    ACTIVE_GROUP_KEYS.id
  );

  const id = Number(value);

  return Number.isInteger(id) && id > 0
    ? id
    : null;
}

export function getActiveGroupName() {
  return (
    localStorage.getItem(
      ACTIVE_GROUP_KEYS.name
    ) || ""
  );
}

export function getActiveGroupRole() {
  return (
    localStorage.getItem(
      ACTIVE_GROUP_KEYS.role
    ) || "member"
  );
}

export function getActiveGroupCapabilities() {
  const stored = localStorage.getItem(
    ACTIVE_GROUP_KEYS.capabilities
  );

  if (!stored) {
    return {};
  }

  try {
    const capabilities = JSON.parse(stored);

    return capabilities &&
      typeof capabilities === "object" &&
      !Array.isArray(capabilities)
      ? capabilities
      : {};
  } catch {
    return {};
  }
}

export function groupHasCapability(
  capability
) {
  if (!capability) {
    return false;
  }

  const capabilities =
    getActiveGroupCapabilities();

  return Boolean(capabilities[capability]);
}

export function groupAllowsBeneficiaries() {
  return groupHasCapability(
    "beneficiaries"
  );
}

export function isActiveGroupAdmin() {
  return [
    "owner",
    "admin",
    "treasurer",
  ].includes(getActiveGroupRole());
}